import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import InquiryLogs from './components/InquiryLogs';
import InquiryWriteForm from './components/InquiryWriteForm';

interface Params {
    type: 'READ' | 'WRITE';
}

const InquiryActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { type } = params;
  const { stepReplace } = useStepFlow('InquiryActivity');
  return (
        <AppScreen>
            <Header title='1:1 문의' />
            <TabList variant='solid'>
                <TabItem selected={type === 'WRITE'}
                         onClick={() => stepReplace({ type: 'WRITE' })}>
                    문의하기
                </TabItem>
                <TabItem selected={type === 'READ'}
                         onClick={() => stepReplace({ type: 'READ' })} >
                    문의 내역
                </TabItem>
            </TabList>
            {type === 'WRITE' && (
                <InquiryWriteForm/>
            )}
            {type === 'READ' && (
                <InquiryLogs/>
            )}
        </AppScreen>
  );
};

export default InquiryActivity;
